import styled from '@emotion/styled'

export const Container = styled.div`
  margin: 10px 10px 10px 0;
`
